<template>
  <div>
    <div :class="{'collapsible':true, 'collapse':!contentShow.accountInfo}">
      <div class="heading" @click="contentShow.accountInfo = !contentShow.accountInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.accountInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.accountInfo"></i>
        <span>{{ $t('consumer.accountInfo.label') }}</span>
      </div>

      <div class="content">
        <div class="field-row">
          <div class="data-field col col50">
            <div class="label">{{ $t('consumer.accountInfo.created') }}:</div>
            <div class="value">{{ userInfo.created }}</div>
          </div>
          <div class="data-field col col50">
            <div class="label">{{ $t('consumer.accountInfo.referralCode') }}:</div>
            <div class="value">{{ userInfo.referralCode }}</div>
          </div>
        </div>
        <div class="field-row">
          <div class="data-field col col100">
            <div class="label">{{ $t('consumer.accountInfo.numberOfReferral') }}:</div>
            <div class="value">
              {{ totalReferrals }}
              <i class="fa fa-circle-notch fa-spin" v-show="referralLoading"></i>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="data-field col col100">
            <a class="button cta small" @click="emailPassword">
              <span v-show="!passwordLoading">{{ $t('consumer.sendResetPassword') }}</span>
              <span v-show="passwordLoading">
                <i class="fa fa-spinner fa-spin"></i>
                {{ $t('consumer.sending') }}
              </span>
            </a>
            <div :class="{'password-status':true, 'show':resetPasswordMessage !== ''}">
              <div class="password-message">
                <i class="fa fa-check" v-show="resetPasswordSuccess"></i>
                <i class="fa fa-times" v-show="!resetPasswordSuccess"></i>
                {{ resetPasswordMessage }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.personalInfo}">
      <div class="heading" @click="contentShow.personalInfo = !contentShow.personalInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.personalInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.personalInfo"></i>
        <span>{{ $t('consumer.personalInfo.label') }}</span>
      </div>

      <div class="content">
        <div class="field-row">
          <div class="data-field col col50">
            <div class="label">{{ $t('consumer.personalInfo.firstName') }}*</div>
            <!-- <div class="value">{{ userInfo.firstName }}</div> -->

            <input type="text" v-model="userInfo.firstName"
              @keyup="fieldValidate('userInfo', 'firstName')"
              :class="{'input':true, 'has-error':!!validation.userInfo.firstName }"/>
            <span class="error-msg">{{ validation.userInfo.firstName }}</span>
          </div>
          <div class="data-field col col50">
            <div class="label">{{ $t('consumer.personalInfo.lastName') }}*</div>
            <!-- <div class="value">{{ userInfo.lastName }}</div> -->
            <input type="text" v-model="userInfo.lastName"
              @keyup="fieldValidate('userInfo', 'lastName')"
              :class="{'input':true, 'has-error':!!validation.userInfo.lastName }"/>
            <span class="error-msg">{{ validation.userInfo.lastName }}</span>
          </div>
        </div>
        <div class="field-row">
          <div class="data-field col col50">
            <div class="label">{{ $t('consumer.personalInfo.email') }}*</div>
            <!-- <div class="value">
              <a v-bind:href="'mailto:' + userInfo.email">{{ userInfo.email }}</a>
            </div> -->
            <input type="text" v-model="userInfo.email"
              @keyup="fieldValidate('userInfo', 'email')"
              :class="{'input':true, 'has-error':!!validation.userInfo.email }"/>
            <span class="error-msg">{{ validation.userInfo.email }}</span>
          </div>
          <div class="data-field col col50">
            <div class="label">{{ $t('consumer.personalInfo.mobile') }}*</div>
            <!-- <div class="value">
              <a @click="call(userInfo)">{{ userInfo.mobile }}</a>
            </div> -->
            <div :class="{'input-group':true, [dialCodeLength]:true}">
              <div class="country-select input-group-label" @click="selectCountry">
                <div class="calling-code">(+{{callingCode}})</div>
                <i class="fa fa-caret-down"></i>
              </div>
              <input type="number" v-model="userInfo.nationalNumber"
                @keyup="fieldValidate('userInfo', 'phone')"
                :class="{'input mobile-input':true, 'has-error':!!validation.userInfo.phone }"/>
            </div>
              <span class="error-msg">{{ validation.userInfo.phone }}</span>
          </div>
        </div>
        <div class="field-row">
          <div class="data-field col col50">
            <div class="label">Date of Birth (YYYY-MM-DD)</div>
            <!-- <datepicker placeholder="Date of Birth" v-model="userInfo.bday"  format="yyyy-MM-dd" class="datepicker" v-on:input="bdayUpdate($event)"></datepicker> -->
            <date-picker v-model="userInfo.bday" valueType="format" :clearable="false" lang="en" class="cons-datepicker"></date-picker>
          </div>
          <div class="data-field col col50">
            <div class="label">Country</div>
            <select class="country-selector" v-model="userInfo.country" placeholder="Country">
              <option value="" disabled>Select Country</option>
              <option v-for="(country, i) in countryList" :key="i" :value="country.code.toUpperCase()">{{cleanCountryName(country.name)}}</option>
            </select>
          </div>
        </div>
        <div class="field-row">
          <div class="data-field col col50">
            <div class="label">Passport Number (Optional)</div>
            <input type="text" v-model="userInfo.passportNum" class="input" />
          </div>
        </div>
        <div class="field-row ada">
          <div class="data-field col col50">
            <div class="label">ADA</div>
            <label :class="{'checked':!!userInfo.wheelChair}">
              <span @click="updateADA('wheel', userInfo.wheelChair)">
                  <i :class="{'fas fa-check-square':true, 'checked':!!userInfo.wheelChair}" v-if="!!userInfo.wheelChair"></i>
                  <i class="far fa-square" v-else></i>
              <span class="ada-label"><i class="fas fa-wheelchair"></i> Wheelchair</span>
                </span>
            </label>
          </div>
          <div class="data-field col col50">
            <div class="label">&nbsp;</div>
            <label :class="{'checked':!!userInfo.serviceDog}">
              <span @click="updateADA('dog', userInfo.serviceDog)">
                  <i class="fas fa-check-square" v-if="!!userInfo.serviceDog"></i>
                  <i class="far fa-square" v-else></i>
              <span class="ada-label"><i class="fas fa-dog"></i> Service Dog</span>
                </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import ApiConsumer from '../../modules/api/consumer/user-info'
// import {countri es} from 'country-data'
// import Datepicker from 'vuejs-datepicker'
import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';
const countryData = require('@/data/countries')
import { userInfo } from 'os'


export default {
  name: 'account-details',
  props: ['referralLoading'],
  components: { DatePicker },
  data () {
    return {
      contentShow:{
        personalInfo: true,
        accountInfo: true
      },
      validation: {
        userInfo: {
          firstName: '',
          lastName: '',
          email: '',
          mobile: '',
          phone: '',
          countryCode: ''
        }
      },
      passwordLoading: false,
      resetPasswordSuccess: false,
      resetPasswordMessage: '',
      currentCodeLength: 0,
      countryList: Object.values(countryData)
    }
  },
  computed: {
    userInfo () { return this.$store.state.consumer.userInfo },
    totalReferrals () {
      return this.$store.state.consumer.referrals.total
    },
    countryCode () {
      let countries = Object.values(countryData)
      if(this.userInfo.countryCode && this.$store.state.consumer.countryCode==='') {
        let countryCode = this.userInfo.countryCode
        let country = {
          code: ''
        }
        if(countryCode===1) {
          country.code = 'us'
        } else if(countryCode===44) {
          country.code = 'gb'
        } else {
          country = countries.find(x => x.dialCode === countryCode)
        }
        this.$store.commit('consumer/setCountryCode', country ? country.code : '')
      }
      this.currentCodeLength = String(this.$store.state.consumer.callingCode).length
      return this.$store.state.consumer.countryCode.toLowerCase()
    },
    callingCode () {
      if(this.userInfo.countryCode && this.$store.state.consumer.callingCode==='') {
        let countryCode = this.userInfo.countryCode
        this.$store.commit('consumer/setCallingCode', countryCode)
      }
      return this.$store.state.consumer.callingCode
    },
    dialCodeLength () {
      let lengthClass = ['', 'small', 'medium', 'large', 'xl', 'xl']
      return lengthClass[this.currentCodeLength - 1]
    },
  },
  methods: {
    selectCountry() {
      this.$store.commit('consumer/setCountryModal', true)
    },
    call (user) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      })
    },
    fieldValidate (parent, child) {
      let self = this
      if (self[parent][child] !== '') {
        this.validation[parent][child] = ''
      }

      self.saveButtonStatusCheck()
    },
    saveButtonStatusCheck () {
      let self = this
      let overAllError = false

      for (let key in self.validation.userInfo) {
        if (self.validation.userInfo[key] !== '') {
          overAllError = true
        }
      }

      self.$store.commit('consumer/setFormHasError', overAllError)
    },
    save () {
      let self = this
      if (self.validateAll()) {
        self.$store.commit('consumer/setFormLoading', true)
        ApiConsumer.updateConsumer(self, self.buildData(), function (res) {
          self.$store.commit('consumer/setFormLoading', false)

          self.$store.commit('consumer/setFormSavingDone', true)
          self.$store.commit('consumer/setFormSaveMessage', self.$t('consumer.formSuccessful'))
          if (res.error) {
            self.$store.commit('consumer/setFormSaveMessage', res.error.message)
          }
        })
      } else {
        self.$store.commit('consumer/setFormLoading', false)
      }
    },
    validateAll () {
      let self = this
      let noError = true
      let errorMsg = {
        empty: self.$t('consumer.emptyField')
      }

      let fields = ['firstName', 'lastName', 'email', 'mobile', 'phone']
      fields.forEach(key => {
        if (self.userInfo[key] === '' || self.userInfo[key] === null) {
          self.validation.userInfo[key] = errorMsg.empty
          noError = false
        }
      })
      if (!this.callingCode) {
        noError = false
        self.validation.userInfo.countryCode
      }

      self.$store.commit('consumer/setFormHasError', !noError)
      return noError
    },
    buildData () {
      let userInfo = this.userInfo
      let tmp = {
        id: userInfo.id,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        email: userInfo.email,
        mobile: this.callingCode+userInfo.phone,
        deviceOS: userInfo.deviceOS,
        deviceModel: userInfo.deviceModel,
        wheelChairLift: userInfo.wheelChair,
        serviceDock: userInfo.serviceDog,
        // phone: userInfo.phone,
        // countryCode: this.callingCode
        phone: `+${this.callingCode}${userInfo.nationalNumber}`,
        countryCode: this.callingCode,
        nationalNumber: userInfo.nationalNumber
      }
      if (userInfo.bday) tmp.dateOfBirth = userInfo.bday
      if (userInfo.country) tmp.userCountry = userInfo.country
      if (userInfo.passportNum) tmp.passportNum = userInfo.passportNum

      return tmp
    },
    emailPassword () {
      let self = this
      self.passwordLoading = true
      self.resetPasswordMessage = ''
      ApiConsumer.emailPassword(self, self.userInfo.id, function (res) {
        self.passwordLoading = false
        self.resetPasswordMessage = self.$t('consumer.passwordSent')
        self.resetPasswordSuccess = true

        if (res.error) {
          self.resetPasswordMessage = res.error.message
          self.resetPasswordSuccess = false
          return
        }
        setTimeout(function () {
          self.resetPasswordMessage = ''
        }, 5000)
      })
    },
    updateADA (ada, value) {
      let self = this
      if(ada==="wheel"){
        if(value) {
          self.userInfo.wheelChair = 0
        } else {
          self.userInfo.wheelChair = 1
        }
      } else {
        if(value) {
          self.userInfo.serviceDog = 0
        } else {
          self.userInfo.serviceDog = 1
        }
      }
    },
    bdayUpdate (val) {
      this.$store.commit('consumer/setuserInfoData', {
        bday: moment(val).format('YYYY-MM-DD')
      })
    },
    cleanCountryName (val) {
      let val2 = val.slice(0, val.indexOf(" ("))
      return val.indexOf(" (") === -1 ? val : val2
    }
  }
}
</script>

<style lang="scss" scoped>
$cta-link: #0D79F2;

.collapsible{
  margin-bottom: 5px;

  .heading{
    color: $cta-link;
    margin-bottom: 2px;
    cursor: pointer;
    text-transform: uppercase;

    i{ margin-right: 5px; }
    span { font-weight: 600; }
  }
  .content{
    margin-left: 6px;
    padding: 5px 0 5px 15px;
    border-left: 2px solid #ddd;
    max-height: 800px; /* define precise max-height for more smoother transition */
    height: auto;
    // overflow: hidden;
    transition:all 0.35s ease-out;

    .field-row{ margin-bottom: 15px; }
    .field-row:last-child{ margin-bottom: 0; }
  }
  &.collapse .content{
    max-height: 0;
    padding: 0 15px;
  }
}
.country-selector{
  padding: 10px;
  margin-top: 5px;
  border-color: #ccc;
  line-height: 1;
}

.ada {
  color: #555;

  .ada-label {
  font-weight: 500;
  }
  }
.field-row{
  box-sizing: border-box;
  display: flex;

  .col{ display: inline-block; }
  .col20{ width: 20%; }
  .col25{ width: 25%; }
  .col40{ width: 40%; }
  .col50{ width: 50%; }
  .col60{ width: 60%; }
  .col80{ width: 80%; }
  .col100{ width: 100%; }

  .checked { color: #0D79F2;}
}

.data-field{
  padding-right: 10px;
  font-weight: 600;

  &.no-label{ padding-top: 17px; }
  .label{
    color: #888;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;
  }
  .value{
    font-size: 17px;
    color: #555;
    word-break: break-all;

    .fa{
      color: $cta-link;
    }
    a{
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .input{
    margin: 5px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.password-status{
  position: relative;
  overflow: hidden;

  .password-message{
    padding: 10px;
    background: #fafafa;
    border:1px solid #eaeaea;
    margin-top:10px;
    position: absolute;
    top: 0;
    left: 0;
    color: #555;

    .fa{ margin-right: 5px; }
    .fa-times{ color: #F20D0D; }
    .fa-check{ color: #26d97a; }
  }
  &.show .password-message{
    position: relative;
    -webkit-animation: slide-down .3s ease-out;
    -moz-animation: slide-down .3s ease-out;
  }
}

.input-group {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  position: relative;
  margin-bottom: 0;

 .input-group-label {
  padding: 0 10px;
  border: 1px solid #cacaca;
  background: #f4f8f9;
  // color: #0a0a0a;
  text-align: center;
  white-space: nowrap;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;

  .calling-code {
    padding-right: 3px;
    font-weight: 100;
  }
 }

 .mobile-input {
  border-radius: 1px;
  border-left: 0;
 }

  &.small {
    .mobile-input {
      padding-left: 35px;
    }
  }
  &.medium {
    .mobile-input {
      padding-left: 45px;
    }
  }
  &.large {
    .mobile-input {
      padding-left: 55px;
    }
  }
  &.xl {
    .mobile-input {
      padding-left: 65px;
    }
  }

}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}

.country-select {
  margin-top: 5px;
  cursor: pointer;
  color: #333;
  transition: 0.3s;
}

.country-select:hover {
  background-color: #e6e6e6;
}

.country-code {
  position: absolute;
  top: 16px;
  left: 60px;
  font-size: 16px;
  font-weight: 100;
}

@-webkit-keyframes slide-down {
  0% { opacity: 0; -webkit-transform: translateY(-100%); }
  100% { opacity: 1; -webkit-transform: translateY(0); }
}
@-moz-keyframes slide-down {
  0% { opacity: 0; -moz-transform: translateY(-100%); }
  100% { opacity: 1; -moz-transform: translateY(0); }
}

@media only screen and (max-width: 430px) {
  .collapsible {
    .content {
      .field-row {
        flex-direction: column;
        margin-bottom: 0;
        .col50 {
          width: 100%;
          display: block;
          margin-bottom: 8px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Consumer/AccountDetails.vue